import React, { Component } from 'react';
import {Button, Select, Option, Checkbox, Textarea} from '@fiverr/fit';
import './VacationForm.scss';
import PropTypes from 'prop-types';
import {submitVacation, isValidDate} from '../../helper';

const WHY_VACATION = ['on_vacation', 'overbooked', 'other'];
const DAYS = [...Array(31).keys()].map((v) => 1+v); // days range 1..31
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const YEARS = [new Date().getFullYear(), new Date().getFullYear() + 1];

const MAX_TEXT_LENGTH = 120;

class VacationForm extends Component {

    constructor(props) {
        super(props);

        const returnDate = typeof(props.dateVal) !== 'undefined' ? new Date(props.dateVal*1000) : new Date(),
            currDate = new Date().setHours(0, 0, 0, 0)/1000;

        this.dateToObj = this.dateToObj.bind(this);
        this.changeVacationReason = this.changeVacationReason.bind(this);
        this.changeBuyerMessage = this.changeBuyerMessage.bind(this);
        this.changeAllowContact = this.changeAllowContact.bind(this);
        this.submit = this.submit.bind(this);

        this.state = {
            endDate: props.dateVal || currDate,
            returnDate: this.dateToObj(returnDate) || '',
            disableSubmit: !returnDate,
            whyVacation: props.whyVacation || '',
            buyerMessage: props.buyerMessage || '',
            allowContact: props.allowContact,
            errorMessage: ''
        };


    }

    dateToObj(date) {
        const dd = date.getDate(),
            mm = date.getMonth() + 1,
            yyyy = date.getFullYear();

        return {
            dd,
            mm,
            yyyy
        };
    }

    changeVacationReason(value) {
        this.setState({
            whyVacation: value,
            buyerMessage: value.length ? i18n.t(`out_of_office.popup.leave_message.${value}`) : ''
        });
    }

    changeAllowContact() {
        this.setState({allowContact: !this.state.allowContact});
    }

    changeBuyerMessage(value) {
        if (value.length < MAX_TEXT_LENGTH) {
            this.setState({
                buyerMessage: value
            });
        }
    }

    changeDate(val, type) {
        const newDate = Object.assign({}, this.state.returnDate);

        let validDate = false,
            end_date = '',
            formatDate = '';

        switch (type) {
            case 'dd': newDate.dd = val;
                break;
            case 'mm': newDate.mm = MONTHS.indexOf(val) + 1;
                break;
            case 'yyyy': newDate.yyyy = val;
                break;
            default: '';
        }

        validDate = isValidDate(newDate);

        if (validDate) {
            formatDate = `${newDate.mm}/${newDate.dd}/${newDate.yyyy}`;
            end_date = new Date(formatDate).getTime()/1000;
        }

        this.setState({
            endDate: validDate ? end_date :this.state.endDate,
            returnDate: newDate,
            disableSubmit : !validDate,
            errorMessage: validDate ? '' : i18n.t('out_of_office.popup.date_invalid')
        });
    }

    submit() {
        const {
            endDate,
            whyVacation,
            buyerMessage,
            allowContact
        } = this.state;

        const requestObj = {
            end_date: endDate,
            reason: whyVacation,
            message_for_buyer: buyerMessage,
            allow_contact: allowContact,
            userId: this.props.userId
        };

        submitVacation(requestObj)
            .then((data) => {
                if (data.status === 'success') {
                    const event = new Event('out_of_office_on');
                    document.dispatchEvent(event);

                    // in case of closing the popup from the submit we send true and e is null
                    this.props.close(null, this.state, true);
                } else {
                    throw '';
                }
            })
            .catch(() => {
                this.setState({
                    globalMessage: i18n.t('out_of_office.error.general')
                });
            });
    }

    render() {

        const {
            returnDate,
            disableSubmit,
            whyVacation,
            buyerMessage,
            allowContact,
            errorMessage,
            globalMessage
        } = this.state;

        const dateClass = `return-select${errorMessage.length ? ' error' : ''}`,
            ddClass = `statuses-select${whyVacation.length ? ' is-active' : ''}`,
            buyerMessageStr = buyerMessage.length ? buyerMessage : ' ',
            textareaStr = <span>{i18n.t('out_of_office.popup.leave_message.title')}<span className="optional">{i18n.t('out_of_office.popup.optional')}</span></span>,
            selectStr = <span>{i18n.t('out_of_office.popup.why_vacation.title')} <span className="optional">{i18n.t('out_of_office.popup.optional')}</span></span>;

        return (
            <div>
                <label htmlFor="vacation-date"></label>
                <label>{i18n.t('out_of_office.popup.returning_date')}</label>
                <div className="vacation-date">
                    <Select value={MONTHS[returnDate.mm - 1]}
                        onChange={(event) => this.changeDate(event.target.value, 'mm')}
                        className={dateClass}>
                        {
                            MONTHS.map((month) => (
                                <Option disabled={month === 'Select'} value={month} key={month}>
                                    {month}
                                </Option>
                            ))
                        }
                    </Select>

                    <Select value={returnDate.dd}
                        onChange={(event) => this.changeDate(Number(event.target.value), 'dd')}
                        className={dateClass}>
                        {
                            DAYS.map((day) => (
                                <Option disabled={day === 'Select'} value={day} key={day}>
                                    {day}
                                </Option>
                            ))
                        }
                    </Select>

                    <Select value={returnDate.yyyy}
                        onChange={(event) => this.changeDate(Number(event.target.value), 'yyyy')}
                        className={dateClass}>
                        {
                            YEARS.map((year) => (
                                <Option disabled={year === 'Select'} value={year} key={year}>
                                    {year}
                                </Option>
                            ))
                        }
                    </Select>
                </div>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                <Select label={selectStr}
                    value={whyVacation}
                    onChange={(event) => this.changeVacationReason(event.target.value)}
                    name="vacation_type"
                    className={ddClass}>
                    <Option value="" key="select">
                        {i18n.t('out_of_office.popup.why_vacation.options.select')}
                    </Option>
                    {
                        WHY_VACATION.map((vacationType) => (
                            <Option disabled={vacationType === 'Select'} value={vacationType} key={vacationType}>
                                {i18n.t(`out_of_office.popup.why_vacation.options.${vacationType}`)}
                            </Option>
                        ))
                    }
                </Select>
                <Textarea onChange={this.changeBuyerMessage}
                    maxLength={MAX_TEXT_LENGTH}
                    value={buyerMessageStr}
                    label={textareaStr}/>
                <Checkbox className="checkbox" onChange={this.changeAllowContact} name="allow_new_buyers" caption={i18n.t('out_of_office.popup.allow_new_buyers')} checked={allowContact}/>
                <div className="cf">
                    <Button onClick={this.submit} className="btn-green submit-vacation" text="Activate" disabled={disableSubmit}/>
                    {globalMessage && <div className="error-message">{globalMessage}</div>}
                </div>
            </div>
        );
    }
}

VacationForm.propTypes = {
    close: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
    whyVacation: PropTypes.string,
    buyerMessage: PropTypes.string,
    allowContact: PropTypes.bool
};

VacationForm.defaultProps = {
    userId: 0,
    whyVacation: '',
    buyerMessage: '',
    allowContact: false,
    close: () => null
};

export default VacationForm;


// WEBPACK FOOTER //
// ./src/VacationPopup/VacationForm/VacationForm.js